import React, { useState } from "react"
import ContactSalesModal from "components/ContactSalesModal"
import { openModal } from "utils/openModal"
import Button from "components/ui/Button"
import Container from "components/ui/Container"

function SingleCTASection() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  return (
    <section className="bg-cove py-20">
      <Container>
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-bold uppercase tracking-widest text-sage">
            Not sure which model is right for you?
          </p>
          <h2 className="mt-4 text-4xl font-bold leading-tighter text-white md:text-5xl">
            Let&apos;s design your deployment together
          </h2>
          <p className="mt-5 text-xl text-sage">
            Every enterprise environment is different. Our team will help you
            identify the right fit based on your security, compliance, and
            operational requirements.
          </p>
          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            <Button
              color="green"
              size="medium"
              href="/contact-sales/"
              onClick={openModal(setIsModalOpen)}
              trackClick="Talk to an Expert (cta)_Deploy Anywhere"
              shadow
            >
              Talk to an Expert
            </Button>
          </div>
        </div>
      </Container>
      <ContactSalesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        sourcePage="deploy-anywhere-cta"
      />
    </section>
  )
}

export default SingleCTASection
